@if (isVisible()) {
  <a
    (click)="emitGtmEvent()"
    [routerLink]="frame()?.url"
    class="block h-10 w-full bg-purple text-[12px] leading-tight desk:text-[16px]">
    <div class="centered-with-padding relative grid h-full grid-cols-[1fr_auto] items-center justify-center">
      @if (banner()?.text; as text) {
        <span [innerHTML]="text" class="line-clamp-2 desk:text-center" handleHtmlLinks></span>
      } @else {
        <span
          aria-hidden="true"
          class="h-3 w-3/4 animate-pulse rounded bg-white/50 motion-reduce:animate-none desk:mx-auto desk:w-1/3"></span>
      }
      <div
        (click)="close(); $event.stopPropagation(); $event.preventDefault()"
        class="mr-[-14px] flex size-10 cursor-pointer items-center justify-center">
        <app-svg [height]="10" [inline]="true" [width]="10" src="assets/icons/close.svg" />
      </div>
    </div>
  </a>
}
